export var DEFAULT_BOTTOM_OFFSET = '0px';